<template>
    <ProvisionalEntryForm />
</template>

<script>
import ProvisionalEntryForm from "@/components/ProvisionalEntryForm.vue";

export default {
    name: 'ProvisionalEntryView',
    components: {
        ProvisionalEntryForm
    }
}
</script>
